import LabServiceCollection from "../LabServiceCollection";
import AnalyteResultStatusModel from "@/models/lab/AnalyteResultStatusModel";

export default class AnalyteResultStatusCollection extends LabServiceCollection {
  model() {
    return AnalyteResultStatusModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddAsc('order');
  }

}
